
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import Vue from "vue";
import AppBankEdit from "@/components/bank/QuickEdit.vue";
import { Deposit } from "@/models/base/deposit";
import AppTicketRefundModal from "@/components/cashier/TicketRefundModal.vue";
import {DossierConfigService} from "@/services";
import { ConfirmResult } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		selectedDeposit():Deposit | null {
			return this.state.createdDepositsData.deposits[this.state.createdDepositsData.deposits.length-1] || null;
		},
		showTicketRefundModal():boolean {
			let c = DossierConfigService.getSaleConfig(1);
			return this.state.config != null && c.ShowTicketRefundDisplay;
		}
	},
	methods: {
		async onSaved(){
			this.state.createdDepositsData.deposits.shift();
			if (this.state.createdDepositsData.deposits.length == 0) {
				if (!this.state.createdDepositsData.modalCallback) return;
				this.state.createdDepositsData.modalCallback(ConfirmResult.YES);
			}
		},
		close(){
			if (!this.state.createdDepositsData.modalCallback) return;
			this.state.createdDepositsData.modalCallback(ConfirmResult.CANCEL);
		}
	},
	components: {
		AppBankEdit,
		AppTicketRefundModal
	}
});
